import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { QuizQuestion, QuizQuestionDto, QuizQuestionValue, QuizQuestionValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getQuizQuestion(id: string): Observable<QuizQuestion> {
        return this.httpClient.get<QuizQuestionDto>(`quiz-questions/${id}`).pipe(map((dto) => new QuizQuestion(dto)));
    }

    createQuizQuestion(value: QuizQuestionValue): Observable<QuizQuestion> {
        const dto = new QuizQuestionValueDto(value);
        return this.httpClient.post<QuizQuestionDto>('quiz-questions', dto).pipe(map((response) => new QuizQuestion(response)));
    }

    updateQuizQuestion(id: string, value: QuizQuestionValue): Observable<QuizQuestion> {
        const dto = new QuizQuestionValueDto(value);
        return this.httpClient.patch<QuizQuestionDto>(`quiz-questions/${id}`, dto).pipe(map((response) => new QuizQuestion(response)));
    }

    deleteQuizQuestion(id: string): Observable<void> {
        return this.httpClient.delete<void>(`quiz-questions/${id}`);
    }
}
